











import {Vue, Component, Prop} from 'vue-property-decorator'
import {Notification as NotificationModel} from "@api/models/notifications/Notification";
import NotificationCampaing from "./types/NotificationCampaing.vue";
import NotificationComment from "./types/NotificationComment.vue";
import NotificationPoints from "./types/NotificationPoints.vue";
import NotificationProfileLike from "./types/NotificationProfileLike.vue";
import NotificationFavorite from "./types/NotificationFavorite.vue";
import NotificationPostLike from "./types/NotificationPostLike.vue";
import { NotificationTypes } from '@api/enums/NotificationTypes';
import {UserProfile} from "@api/models/UserProfile";

@Component({
    components: { NotificationCampaing, NotificationComment, NotificationPoints, NotificationProfileLike, NotificationFavorite, NotificationPostLike }
})
export default class Notification extends Vue {
    @Prop() notification: NotificationModel;
    @Prop() profile: UserProfile|null;

    get isCampaignNotification(): boolean {
        return this.notification.type == NotificationTypes.campaign;
    }

    get isCommentNotification(): boolean {
        return this.notification.type == NotificationTypes.comment;
    }

    get isPointsNotification(): boolean {
        return this.notification.type == NotificationTypes.points;
    }

    get isLikeNotification(): boolean {
        return this.notification.type == NotificationTypes.like;
    }

    get isFavoriteNotification(): boolean {
        return this.notification.type == NotificationTypes.favorite;
    }

    get isPostLikeNotification(): boolean {
        return this.notification.type == NotificationTypes.postLike || this.notification.type == NotificationTypes.gembaLike;
    }
}
